import { useTranslation } from 'react-i18next';
import { useFormContext, useWatch } from 'react-hook-form';
import { ExternalScheduleMaterialInputsProps } from './types';
import { ExternalScheduleFormValues } from '@forms/schedules/external/types';
import { ExternalScheduleMaterialInput } from './option';
import React from 'react';

export const ExternalScheduleMaterialInputs = ({
  material,
  editable,
  disabled,
}: ExternalScheduleMaterialInputsProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'forms' });
  const { control } = useFormContext<ExternalScheduleFormValues>();
  const materialOptions = useWatch({ control, name: 'materialOptions' });

  return (
    <div className="grid grid-cols-2 gap-4">
      {material?.options?.map((option) => {
        const index = editable
          ? (materialOptions || []).findIndex((el) => el.id === option.id)
          : -1;

        return (
          <React.Fragment key={option.id}>
            {option.includeEstimated && (
              <ExternalScheduleMaterialInput
                option={option}
                index={index}
                quantity="estimatedQuantity"
                label={t('estimatedUnits.label', { name: option?.name, unit: option?.unit || '' })}
                className="col-start-1"
                disabled={disabled}
              />
            )}
            <ExternalScheduleMaterialInput
              option={option}
              index={index}
              quantity="finalQuantity"
              label={
                option.includeEstimated
                  ? t('finalUnits.label', { name: option?.name, unit: option?.unit || '' })
                  : `${option?.name} ${option?.unit}`
              }
              className={option.includeEstimated ? 'col-start-2' : 'col-start-1 col-end-3'}
              disabled={disabled}
            />
          </React.Fragment>
        );
      })}
    </div>
  );
};
